import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=3086fa74&scoped=true&"
import script from "./nodata.vue?vue&type=script&lang=js&"
export * from "./nodata.vue?vue&type=script&lang=js&"
import style0 from "./nodata.vue?vue&type=style&index=0&id=3086fa74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086fa74",
  null
  
)

export default component.exports